import React, { lazy } from "react";
import { ChatNuevoProvider } from "./pages/clientsleadsnuevo/ChatNuevoContext";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  defer,
} from "react-router-dom";
import BoardLayout from "./components/template/BoardLayaout";
import { AuthLayout } from "./components/security/AuthLayout";
import { getAuthData } from "./utils/LocalStorageManager";

const HomeLayout = lazy(() => import("./components/template/HomeLayout"));
const ForgotPassword = lazy(() =>
  import("./pages/forgotPassword/ForgotPassword")
);
const RecoveryPassword = lazy(() =>
  import("./pages/recoveryPassword/RecoveryPassword")
);
const ActiveRegister = lazy(() =>
  import("./pages/activeRegister/ActiveRegister")
);
const Users = lazy(() => import("./pages/users/Users"));
const MaintenanceUser = lazy(() => import("./pages/users/MaintenanceUsers"));
const Clients = lazy(() => import("./pages/clients/Clients"));
const MaintenanceClient = lazy(() =>
  import("./pages/clients/MaintenanceClient")
);
const ClientsLeads = lazy(() => import("./pages/clientsleads/ClientsLeads"));
const Vendors = lazy(() => import("./pages/vendors/Vendors"));
const MaintenanceVendor = lazy(() => import("./pages/vendors/MaintenanceVendor"));


const ClientsLeadsNuevo = lazy(() => import("./pages/clientsleadsnuevo/ClientsLeadsNuevo"));
const ChatNuevo = lazy(() => import("./pages/clientsleadsnuevo/ChatNuevo"));
const ClientInfoPage = lazy(() => import("./pages/clientinfo/ClientInfoPage"));
const EmailComposerPage = lazy(() => import("./pages/email/EmailComposerPage"));
const LeadEmailPage = lazy(() => import("./pages/email/LeadEmailPage"));

const MaintenanceClientLeadNuevo = lazy(() =>
  import("./pages/clientsleadsnuevo/MaintenanceClientLeadNuevo")
);


const Companies = lazy(() => import("./pages/companies/Companies"));
const CustomerStatus = lazy(() => import("./pages/customerStatus/CustomerStatus"));
const LeadTag = lazy(() => import("./pages/leadTag/LeadTag"));
const MaintenanceClientLead = lazy(() =>
  import("./pages/clientsleads/MaintenanceClientLead")
);
const Form = lazy(() => import("./pages/form/Form"));
const Login = lazy(() => import("./pages/login/Login"));
const Whatsapp = lazy(() => import("./pages/whatsapp/Whatsapp"));
const Dashboard = lazy(() => import("./pages/dashboard/Dashboard"));
const AutoReply = lazy(() => import("./pages/autoreply/AutoReply"));

const TemplateQuickResponse = lazy(() =>
  import("./pages/templatesQuickResponse/TemplatesQuickResponse")
);
const MaintenanceTemplateQuickResponse = lazy(() =>
  import("./pages/templatesQuickResponse/MaintenanceTemplatesQuickResponse")
);
const TemplatesTwilio = lazy(() =>
  import("./pages/templatesTwilio/TemplatesTwilio")
);
const MaintenanceTemplatesTwilio = lazy(() =>
  import("./pages/templatesTwilio/MaintenanceTemplatesTwilio")
);
const TemplatesEmail = lazy(() =>
  import("./pages/templatesEmail/TemplatesEmail")
);
const MaintenanceTemplatesEmail = lazy(() =>
  import("./pages/templatesEmail/MaintenanceTemplatesEmail")
);

const MessageMassive = lazy(() => import("./pages/massive/MessageMassive"));
const MessageMassiveDetail = lazy(() =>
  import("./pages/massive/MessageMassiveDetail")
);
const Settings = lazy(() => import("./pages/settings/Settings"));
const AIClientConfig = lazy(() => import("./pages/settings/AIClientConfig"));
const FollowUpRules = lazy(() => import("./pages/settings/FollowUpRules"));
const WebhookIntegrations = lazy(() => import("./pages/settings/WebhookIntegrations"));
const CountryOwners = lazy(() => import("./pages/settings/CountryOwners"));
const GoogleAds = lazy(() => import("./pages/googleads/GoogleAds"));
/*  */
// Reportes
const ReportesPage = lazy(() => import("./pages/reportes/ReportesPage"));
const ReportesMensualPage = lazy(() => import("./pages/reportes/ReportesMensualPage"));
const ReportesFunnelPage = lazy(() => import("./pages/reportes/ReportesFunnelPage"));

// Proposal Generator
const GeneratorHome = lazy(() => import("./pages/proposal-generator/GeneratorHome"));
const GeneratorMultistep = lazy(() => import("./pages/proposal-generator/GeneratorMultistep"));
const GeneratorPreview = lazy(() => import("./pages/proposal-generator/GeneratorPreview"));
const ProposalList = lazy(() => import("./pages/proposal-generator/ProposalList"));

// Marketing
const MarketingPage = lazy(() => import("./pages/marketing/MarketingPage"));
const MarketingWADetailPage = lazy(() => import("./pages/marketing/MarketingWADetailPage"));

export const appRoutes = createBrowserRouter(
  createRoutesFromElements(
    <Route
      element={<AuthLayout />}
      loader={async () => defer({ authPromise: getAuthData() })}
    >
      <Route element={<HomeLayout />}>
        <Route exact path="/" element={<Login />} />
        <Route exact path="/recoverPassword" element={<RecoveryPassword />} />
        <Route
          exact
          path="/forgotPassword/:code/:email"
          element={<ForgotPassword />}
        />
        <Route
          exact
          path="/activeRegister/:code/:email"
          element={<ActiveRegister />}
        />
      </Route>

      <Route path="/dashboard" element={<BoardLayout />}>
        <Route exact path="whatsapp" element={<Whatsapp />} />

        <Route path="home" element={<Dashboard />} />
        <Route exact path="users" element={<Users />} />
        <Route
          exact
          path="users/maintenanceUser"
          element={<MaintenanceUser />}
        />
        <Route exact path="clients" element={<Clients />} />
        <Route
          exact
          path="clients/maintenanceClient"
          element={<MaintenanceClient />}
        />
        <Route exact path="vendors" element={<Vendors />} />
        <Route
          exact
          path="vendors/maintenanceVendor"
          element={<MaintenanceVendor />}
        />
        <Route exact path="clientsLeads" element={<ClientsLeads />} />
        <Route
          exact
          path="clientsLeads/maintenanceClientLead"
          element={<MaintenanceClientLead />}
        />
        
        
        <Route exact path="clientsLeadsNuevo" element={<ClientsLeadsNuevo />} />
        <Route
          exact
          path="clientsLeadsNuevo/maintenanceClientLeadNuevo"
          element={<MaintenanceClientLeadNuevo />}
        />


        <Route exact path="companies" element={<Companies />} />
        <Route exact path="customerStatus" element={<CustomerStatus />} />
        <Route exact path="leadTag" element={<LeadTag />} />
        <Route exact path="form" element={<Form />} />
        <Route exact path="setting" element={<Settings />} />
        <Route exact path="setting/autoreply" element={<AutoReply />} />
        {/* <Route exact path="form" element={<Form />} /> */}
        <Route exact path="setting/companies" element={<Companies />} />
        <Route exact path="setting/users" element={<Users />} />
        <Route
          exact
          path="setting/users/maintenanceUser"
          element={<MaintenanceUser />}
        />
        <Route
          exact
          path="setting/template/whatsapp/twilio"
          element={<TemplatesTwilio />}
        />
        <Route
          exact
          path="setting/template/whatsapp/twilio/maintenance"
          element={<MaintenanceTemplatesTwilio />}
        />
        <Route
          exact
          path="setting/template/email"
          element={<TemplatesEmail />}
        />
        <Route
          exact
          path="setting/template/email/maintenance"
          element={<MaintenanceTemplatesEmail />}
        />
        <Route
          exact
          path="setting/template/whatsapp/quickresponse"
          element={<TemplateQuickResponse />}
        />
        <Route
          exact
          path="setting/template/whatsapp/quickresponse/maintenance"
          element={<MaintenanceTemplateQuickResponse />}
        />
        <Route exact path="setting/massive" element={<MessageMassive />} />
        <Route
          exact
          path="setting/massive/detail"
          element={<MessageMassiveDetail />}
        />
        <Route exact path="setting/ai-config" element={<AIClientConfig />} />
        <Route exact path="setting/follow-up-rules" element={<FollowUpRules />} />
        <Route exact path="setting/webhook-integrations" element={<WebhookIntegrations />} />
        <Route exact path="setting/country-owners" element={<CountryOwners />} />
        {/* <Route exact path="setting/template/whatsapp/autoreply" element={<TemplateAutoReply />} />
            <Route exact path="setting/template/whatsapp/autoreply/stages" element={<TemplateAutoReplyStages />} />
            <Route exact path="setting/template/whatsapp/autoreply/stages/responses" element={<TemplateAutoReplyResponse />} /> */}
        <Route exact path="googleads" element={<GoogleAds />} />
        <Route exact path="reportes/semanal" element={<ReportesPage />} />
        <Route exact path="reportes/mensual" element={<ReportesMensualPage />} />
        <Route exact path="reportes/funnel" element={<ReportesFunnelPage />} />
       <Route
         exact
         path="chat"
         element={
           <ChatNuevoProvider>
             <ChatNuevo />
           </ChatNuevoProvider>
         }
       />
       <Route exact path="client-info" element={<ClientInfoPage />} />
       <Route exact path="email-composer" element={<EmailComposerPage />} />
       <Route exact path="lead-email" element={<LeadEmailPage />} />

        {/* Marketing */}
        <Route exact path="marketing" element={<MarketingPage />} />
        <Route exact path="marketing/campana-detail" element={<MarketingWADetailPage />} />

        {/* Proposal Generator */}
        <Route exact path="proposals" element={<ProposalList />} />
        <Route exact path="proposal-generator" element={<GeneratorHome />} />
        <Route
          exact
          path="proposal-generator/create"
          element={<GeneratorMultistep />}
        />
        <Route
          exact
          path="proposal-generator/view/:id"
          element={<GeneratorMultistep />}
        />
        <Route
          exact
          path="proposal-generator/preview"
          element={<GeneratorPreview />}
        />
      </Route>
   </Route>
 )
);
